import { Chip } from "@mui/material";
import React from "react";
import { colors } from "../utils/Constants";

const BetaBadge = ({ props }) => {
    return (
        <Chip
            label="BETA"
            {...props}
            sx={{
                borderRadius: "4px",
                height: "20px",
                fontSize: "14px",
                fontWeight: 400,
                backgroundColor: colors.MB_CAUTION_COLOR_MAIN,
                color: "white",
                boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.25)",
                "&:hover, &.Mui-focusVisible": {
                    backgroundColor: colors.MB_CAUTION_COLOR_MAIN,
                    color: "white",
                    outline: "none",
                    cursor: "default"
                }
            }}
        />
    );
};

export default BetaBadge;
